import type { CheckoutConfig } from '#types/config/components/checkout'

export default {} satisfies CheckoutConfig['cartContainer']
